<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M4.25 8.75C3.55964 8.75 3 9.30964 3 10C3 10.6904 3.55964 11.25 4.25 11.25C4.94036 11.25 5.5 10.6904 5.5 10C5.5 9.30964 4.94036 8.75 4.25 8.75Z"
            fill="currentColor"
        />
        <path
            d="M10 8.75C9.30964 8.75 8.75 9.30964 8.75 10C8.75 10.6904 9.30964 11.25 10 11.25C10.6904 11.25 11.25 10.6904 11.25 10C11.25 9.30964 10.6904 8.75 10 8.75Z"
            fill="currentColor"
        />
        <path
            d="M15.75 8.75C15.0596 8.75 14.5 9.30964 14.5 10C14.5 10.6904 15.0596 11.25 15.75 11.25C16.4404 11.25 17 10.6904 17 10C17 9.30964 16.4404 8.75 15.75 8.75Z"
            fill="currentColor"
        />
    </svg>
</template>
